<template>
  <div>
    <mdb-tbl sm>
      <mdb-tbl-head>
        <tr>
          <th>훈련명</th>
          <th>기간</th>
          <th>강사</th>
          <th style="width:100px">진행률</th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body>
        <tr v-for="t in trainings" :key="t._id">
          <td class="pointer py-1" @click="$emit('select-training',t)">{{t.name}}</td>
          <td class="py-1" >{{$strDate(t.startDate)}}~{{$strDate(t.endDate)}}</td>
          <td class="py-1">{{t.teacher && t.teacher.name}}</td>
          <td class="py-1">
            <mdb-progress class="" :height="18" :value="progress(t)" color="indigo">{{progress(t)}}%</mdb-progress>
          </td>
        </tr>
      </mdb-tbl-body>
    </mdb-tbl>
  </div>
</template>
<script>
import { mdbTbl, mdbTblHead, mdbTblBody, mdbProgress } from 'mdbvue';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  name: 'TrainingList',
  components: { mdbTbl, mdbTblHead, mdbTblBody, mdbProgress },
  props: ['trainings'],
  methods: {
    progress (t) {
      return this.$progress(t.startDate, t.endDate)
    }
  }
}
</script>
